import React from 'react';
import { Card } from '../ui/Card';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sofía R.',
    age: '34 años',
    location: 'Miami, FL',
    text: 'Mis cremas siempre se separaban al día siguiente. Con este método entendí la importancia de la temperatura y el orden de las fases. Ahora hago emulsiones perfectas que duran meses.',
    highlight: 'Antes: Se separaba → Ahora: Estable'
  }, {
    name: 'Elena M.',
    age: '42 años',
    location: 'San Diego, CA',
    text: "Yo hacía todo 'a ojo' y a veces salía bien, a veces mal. Desde que uso la balanza y los porcentajes del libro, mis resultados son consistentes. Ya no tiro ingredientes a la basura.",
    highlight: 'Antes: A ojo → Ahora: Exactitud'
  }, {
    name: 'Carla P.',
    age: '29 años',
    location: 'Austin, TX',
    text: 'Los jabones que hacía antes me dejaban la piel tirante. Aprendí a formular con los tensioactivos correctos y ahora mi limpiador facial es una maravilla, súper suave.',
    highlight: 'Antes: Resecaba → Ahora: Suave'
  }, {
    name: 'Marta G.',
    age: '51 años',
    location: 'Orlando, FL',
    text: 'Mis bálsamos quedaban como piedras o muy líquidos. Con la tabla de corrección de fallos pude ajustar la cera y ahora tienen la textura comercial perfecta.',
    highlight: 'Antes: Textura mal → Ahora: Perfecta'
  }, {
    name: 'Valentina S.',
    age: '38 años',
    location: 'New York, NY',
    text: 'Tenía mucho miedo de los conservantes y la seguridad. El módulo de higiene me dio la confianza para empezar a vender mis primeros kits a mis amigas por WhatsApp.',
    highlight: 'Resultado: Primeras ventas'
  }, {
    name: 'Isabella L.',
    age: '45 años',
    location: 'Los Angeles, CA',
    text: 'Pensé que sería muy químico, pero es súper natural. Me encanta que explica el por qué de cada cosa. Ya hice toda la línea de cuidado facial para mí y mi hija.',
    highlight: 'Resultado: Confianza total'
  }];
  return <section className="py-20 bg-[#F5F2EA]" data-id="element-272">
      <div className="container mx-auto px-4" data-id="element-273">
        <div className="text-center mb-16" data-id="element-274">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-275">
            Ellas ya están creando su propia cosmética
          </h2>
          <p className="text-lg text-gray-600" data-id="element-276">
            Historias reales de alumnas que pasaron de la frustración al
            orgullo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-277">
          {testimonials.map((t, i) => <Card key={i} className="p-6 h-full flex flex-col relative bg-white" data-id="element-278">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-[#4A6741]/10" data-id="element-279" />
              <div className="flex gap-1 mb-4" data-id="element-280">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-[#C06C54] fill-current" data-id="element-281" />)}
              </div>
              <p className="text-gray-700 mb-6 flex-grow italic" data-id="element-282">"{t.text}"</p>

              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-283">
                <p className="font-bold text-gray-900" data-id="element-284">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-285">
                  {t.age} • {t.location}
                </p>
                <div className="mt-2 inline-block bg-[#4A6741]/10 text-[#4A6741] text-xs px-2 py-1 rounded font-medium" data-id="element-286">
                  {t.highlight}
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}